export default __webpack_public_path__ + "static/media/mern-stack.f9e87892.jpg";